export default () => {
    return {
        mounted() {
            const alerts = document.querySelectorAll('.alert-bar')
            const closeButtons = document.querySelectorAll('.close-alert')
            const dismissed = sessionStorage.getItem('dismissed')

            if (dismissed == 'false' || dismissed == null) {
                sessionStorage.setItem('dismissed', 'false')
            } else {
                for (const alert of alerts) {
                    alert.classList.add('hidden')
                }
            }

            function setAlertStatus() {
                sessionStorage.setItem('dismissed', 'true')
            }

            for (const close of closeButtons) {
                close.addEventListener('click', setAlertStatus)
            }
        },
    }
}
